import React from "react";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <p className="copyright">
              © {currentYear} <a href="https://rushabhsorathiya.com">Rushabh Sorathiya</a>. All rights reserved. Built with ❤️ and ☕
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
